/**
 * Strips facet segments from a URL path, returning only the category and hierarchy.
 *
 * Facets are identified by the `-/` separator in URLs.
 *
 * @example
 * stripFacetsFromUrl('/campsites/England/Hampshire/-/electric/')
 * // Returns: '/campsites/England/Hampshire/'
 *
 * @example
 * stripFacetsFromUrl('/glamping/-/hot-tub/')
 * // Returns: '/glamping/'
 *
 * @example
 * stripFacetsFromUrl('/campsites/England/')
 * // Returns: '/campsites/England/' (no facets to strip)
 *
 * @param url - The URL path (or full URL) to strip facets from
 * @returns The URL with facets removed, preserving trailing slash
 */
export function stripFacetsFromUrl(url: string): string {
  if (!url) {
    return url
  }

  // Split on the facet separator '-/'
  const [hierarchyPart] = url.split('-/')

  // Ensure we have a hierarchy part
  if (!hierarchyPart) {
    return url
  }

  // Ensure trailing slash is preserved
  if (!hierarchyPart.endsWith('/')) {
    return `${hierarchyPart}/`
  }

  return hierarchyPart
}
